import { NgClass } from '@angular/common';
import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

import { ScrollSpyDirective } from '../../shared/scroll-spy/scroll-spy.directive';

@Component({
  selector: 'mb-section-headline',
  templateUrl: './section-headline.component.html',
  styleUrls: ['./section-headline.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ScrollSpyDirective, NgClass],
})
export class SectionHeadlineComponent {
  @HostBinding('class.has-headline')
  @Input()
  headline = '';
  @Input() anchor = '';
  @Input() theme: string = 'inherit'; // 'dark' | 'light' | 'inherit'
  @Input() containerClass: string = 'container-sm';
}
